import { memo } from "react";

import StraightenIcon from "@material-ui/icons/Straighten";

import { ToolbarButton } from "components/base";

import { useXdaSettingsStore } from "../../context";
import { selectShowMeasurement } from "../../context/xdaSettingsSelectors";

const XdaMeasurementToggle = () => {
  const showMeasurement = useXdaSettingsStore(selectShowMeasurement);
  const updateXdaSettings = useXdaSettingsStore((s) => s.updateXdaSettings);
  const handleToggle = () => (value) => {
    updateXdaSettings({ showMeasurement: value });
  };

  return (
    // "Key" will help react to re-render the button and correct the state of tooltip
    // Without re-render, tooltip will remember the state of mouse-over -> tooltip not closed even tho the window was already expanded/collapsed
    <ToolbarButton
      key={"FullscreenToggleButton" + showMeasurement}
      active={showMeasurement}
      icon={<StraightenIcon fontSize="large" />}
      tooltipText="Toggle Measurement Tool"
      overflowLabel={"Measurement"}
      onToggle={handleToggle()}
      styleKey="xdaToolbar"
    />
  );
};

export default memo(XdaMeasurementToggle);
